import { render, staticRenderFns } from "./mineNews.vue?vue&type=template&id=4c7fd8f3&scoped=true"
import script from "./mineNews.vue?vue&type=script&lang=js"
export * from "./mineNews.vue?vue&type=script&lang=js"
import style0 from "./mineNews.vue?vue&type=style&index=0&id=4c7fd8f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7fd8f3",
  null
  
)

export default component.exports